// @flow

const getFooterElem = (footerId: string): { offsetHeight: number } | HTMLElement => {
  let footerElem = document.getElementById(footerId);

  if (!footerElem) {
    footerElem = { offsetHeight: 0 };
  }

  return footerElem;
};

class ScrollHandler {
  handleCheckIfShouldContinue: Function;

  handleCallback: Function;

  scrollParams: {
    footerHeight: number,
    html: HTMLElement,
    body: HTMLElement
  };

  constructor(checkIfShouldContinue: Function = () => {}, callback: Function = () => {}, additionalElementHeight = 0) {
    const { body } = document;

    this.handleCheckIfShouldContinue = checkIfShouldContinue;
    this.handleCallback = callback;
    this.scrollParams = {
      footerHeight: getFooterElem('main-footer').offsetHeight + additionalElementHeight,
      html: document.documentElement,
      body
    };

    this.listen();
  }

  compute = () => {
    if (!this.handleCheckIfShouldContinue()) return;

    const documentHeight = Math.max(
      this.scrollParams.body.scrollHeight,
      this.scrollParams.body.offsetHeight,
      this.scrollParams.html.clientHeight,
      this.scrollParams.html.scrollHeight,
      this.scrollParams.html.offsetHeight
    );

    if (window.scrollY + window.innerHeight >= documentHeight - this.scrollParams.footerHeight) {
      this.handleCallback();
    }
  };

  listen = () => {
    document.addEventListener('scroll', this.compute);
  };

  unlisten = () => {
    document.removeEventListener('scroll', this.compute);
  };
}

export default ScrollHandler;
